import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REFRESH_ACCESS_TOKEN_MUTATION } from '../graphql/mutations'
import { REFRESH_TOKEN } from '../redux/action-types'

const useRefreshTokenMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store?.account?.refreshAccessToken,
  )

  const mutate = useCallback(
    async refreshToken =>
      apolloService.mutate(
        REFRESH_ACCESS_TOKEN_MUTATION,
        { refreshToken },
        dispatch,
        REFRESH_TOKEN,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useRefreshTokenMutation
